import React, { useState } from 'react';
import Typewriter from 'typewriter-effect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoffee, } from '@fortawesome/free-solid-svg-icons'
import sabbir from '../../images/sabbir.png'
import img from '../../images/sabbir.jpg'
import { useSpring, animated } from 'react-spring'

import { FaGithub, FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";

import Particles from "react-tsparticles";
import "./AboutMe.css"





const AboutMe = () => {
    const particlesInit = (main) => {
        console.log(main);
    
      };
    
      const particlesLoaded = (container) => {
        console.log(container);
      };
    
    
      const [flip, set] = useState(false)

    return (
        <div>
             <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        fpsLimit: 120,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "repulse",
            },
            resize: true,
          },
          modes: {
            bubble: {
              distance: 4000,
              duration: 5,
              opacity: 0.8,
              size: 40,
            },
            push: {
              quantity: 0,
            },
            repulse: {
              distance: 50,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: "#FFD700",
          },
          links: {
            color: "#FFD700",
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            // direction: "none",
            enable: true,
            // outMode: "bounce",
            // random: true,
            speed: 2,
            // straight: true,
          },
          number: {
            density: {
              enable: true,
              area: 900,
            },
            value: 50,
          },
          opacity: {
            value: 0.5,
          },
          shape: {
            type: "ploygon",
          },
          size: {
            random: true,
            value: 10,
          },
        },
        detectRetina: true,
      }}
    />
        <div className='first-banner'>
             
            
            <div className='first-section' >
                <div className='about-me text-center'>
                    <div className='row'  >
                       <animated.div style={useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    reset: true,
    reverse: flip,
    delay: 200,
    
    onRest: () => set(!flip),
  })} >  </animated.div> <div className='col-md-6 col-lg-6 col-sm-12' 
     
     >
                            <h1 className='about-title font animate__heartBeat'>
                                HI ! <br /> I'M SABBIR AHMED
                            </h1>
                            <div className='about'>
                                <div className='autoType'>
                                    <Typewriter

                                        options={{
                                            strings: [
                                                "Web Developer",
                                                "Programmer",
                                                "React Developer",
                                                "JavaScript Developer",
                                            ],

                                            autoStart: true,
                                            loop: true,
                                            delay: 100,
                                        }}
                                    />
                                </div>
                                <p className='mt-2 paragraph animate__heartBeat animate__zoomInUp'  >   I am an enthusiastic JavaScript developer with knowing some
                                    framework for the frontend and the backend. I know Basic 
                                    and MySQL but basically a MERN developer.</p>

                            </div>
                            {/* link div */}
                            <div className='animate__heartBeat animate__zoomInUp'>
                               <button className='icon-button '>
                                    <a className='icon-button' href="https://github.com/nayeem98746"><FaGithub></FaGithub></a>
                                    
                                </button>
                               <button className='icon-button'>
                                    <a href="https://www.facebook.com/sabbirahmed.nayeem.10" className='icon-button'>  <FaFacebook></FaFacebook> </a>
                               </button>
                               <button className='icon-button'> <a href="https://www.instagram.com/sabbirahmednayeem/" className='icon-button'> <FaInstagram></FaInstagram> </a></button>
                                <button className='icon-button'><a href="https://www.linkedin.com/in/sabbir-ahmed-b98b0a226/" className='icon-button'> <FaLinkedin></FaLinkedin> </a></button>
                                
                            </div>
                            <div className="mt-4 mb-4 w-100 m-auto row">
                                <div className="col-md-6 col-sm-12">
                                    <button className="btn btn-info mt-3">Hire Me</button>
                                </div>
                                <div className="col-md-6 col-sm-12 mb-5">
                                    <button className="btn btn-info mt-3 resume-download">
                                        <a className=""
                                            href="https://drive.google.com/file/d/1LY372BAC4iOzcMO0UELqvgdc5sjFBSOI/view?usp=sharing"
                                            download
                                        >
                                            Download Resume
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 col-lg-6 col-sm-12 profile-pic mt-4  '  >
                            <img id="image" className=' animate__heartBeat animate__slideInUp' src={img} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
};

export default AboutMe;


